import React from 'react';
import { ArrowRight, ChevronRight } from 'lucide-react';
import Container from '../common/Container';
import Button from '../common/Button';

const CTABanner = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-cyan-700 via-blue-800 to-blue-900 text-white relative overflow-hidden" aria-labelledby="cta-heading">
      {/* Static Background Elements */}
      <div className="absolute right-0 top-0 w-1/2 h-full overflow-hidden">
        <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-cyan-500/20 blur-3xl" aria-hidden="true"></div>
      </div>
      <div className="absolute left-0 bottom-0 w-1/2 h-full overflow-hidden">
        <div className="absolute -left-24 -bottom-24 w-96 h-96 rounded-full bg-blue-400/20 blur-3xl" aria-hidden="true"></div>
      </div>
      
      <Container className="relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center mb-3 bg-white/10 backdrop-blur-sm px-4 py-1.5 rounded-full">
              <span className="w-2 h-2 rounded-full bg-cyan-400 mr-2"></span>
              <span className="text-cyan-100 font-medium text-sm">Let's Connect</span>
            </div>
            
            <h2 id="cta-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
              Ready to transform your <span className="text-cyan-300">industrial processes</span>?
            </h2>
            
            <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-12">
              Let's discuss how our automation solutions can drive efficiency and innovation in your business.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            {/* Static buttons without transitions */}
            <a 
              href="/contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-blue-800 font-medium text-lg rounded-lg shadow-lg"
            >
              <span>Start a Conversation</span>
              <ArrowRight className="ml-2 w-5 h-5" />
            </a>
            
            <a 
              href="/services"
              className="inline-flex items-center justify-center px-8 py-4 bg-cyan-500 text-white font-medium text-lg rounded-lg shadow-lg"
            >
              <span>Explore Services</span>
              <ChevronRight className="ml-2 w-5 h-5" />
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default CTABanner;